import {
  GoogleAuthProvider,
  OAuthProvider,
  signInWithPopup,
  signInWithEmailAndPassword,
  fetchSignInMethodsForEmail,
  linkWithCredential,
  signOut,
} from "firebase/auth";
import { auth } from "../firebaseConfig"; // Firebase authentication initialized here
import { db } from "../firebaseConfig"; // Firestore DB instance
import { doc, setDoc } from "firebase/firestore"; // Firebase Firestore
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";

export const currentUser = async () => {
  const user = auth.currentUser;
  // console.log("Current User:", user.uid);
  if (user) {
    return user;
  } else {
    return null;
  }
};

// Save user credentials to Firestore
const saveUserToDatabase = async (user) => {
  const userRef = doc(db, "Advisers", user.uid); // Create reference to Firestore document
  await setDoc(userRef, {
    uid: user.uid,
    // email: user.email,
    displayName: user.displayName || "",
    // provider: user.providerData[0].providerId,
  });
  
};

// Google Sign-In
export const signInWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: "select_account" });
  try {
    const result = await signInWithPopup(auth, provider);
    await saveUserToDatabase(result.user); // Save to Firestore
    // Redirect to home after sign-in
    return result.user;
  } catch (error) {
    if (error.code === "auth/account-exists-with-different-credential") {
      const email = error.customData.email;
      const signInMethods = await fetchSignInMethodsForEmail(auth, email);

      if (signInMethods.includes("microsoft.com")) {
        const microsoftProvider = new OAuthProvider("microsoft.com");
        const microsoftResult = await signInWithPopup(auth, microsoftProvider);
        await linkWithCredential(microsoftResult.user, error.credential); // Link the accounts
        // Redirect to home
      }
    } else {
      // console.error("Google Sign-In Error:", error);
    }
    throw error;
  }
};

// Microsoft Sign-In
export const signInWithMicrosoft = async () => {
  const provider = new OAuthProvider("microsoft.com");
  try {
    const result = await signInWithPopup(auth, provider);
    await saveUserToDatabase(result.user); // Save to Firestore
    // Redirect to home after sign-in
    return result.user;
  } catch (error) {
    if (error.code === "auth/account-exists-with-different-credential") {
      const email = error.customData.email;
      const signInMethods = await fetchSignInMethodsForEmail(auth, email);

      if (signInMethods.includes("google.com")) {
        const googleProvider = new GoogleAuthProvider();
        const googleResult = await signInWithPopup(auth, googleProvider);
        await linkWithCredential(googleResult.user, error.credential); // Link the accounts
        // Redirect to home
      }
    } else {
      // console.error("Microsoft Sign-In Error:", error);
    }
    throw error;
  }
};

// Email & Password Sign-In
export const signInWithEmail = async (email, password) => {
  // console.log("email", email);
  const auth = getAuth();

  try {
    // Attempt to sign in with email and password
    const userCredential = await signInWithEmailAndPassword(
      auth,
      email,
      password
    );
    // console.log("Successfully signed in:", userCredential.user.email);
    return userCredential.user; // Return the signed-in user
  } catch (error) {
    // If user is not found, attempt to create a new user
    if (error.code === "auth/user-not-found") {
      try {
        const newUserCredential = await createUserWithEmailAndPassword(
          auth,
          email,
          password
        );
        // console.log(
        //   "User not found. New user created:",
        //   newUserCredential.user.email
        // );
        return newUserCredential.user; // Return the newly created user
      } catch (createError) {
        // console.error("Error creating new user:", createError.message);
        throw createError; // Rethrow error if user creation fails
      }
    } else {
      // console.error("Error during sign-in:", error.message);
      throw error; // Rethrow error if it's not a "user not found" error
    }
  }
};

// Logout Function
export const logOutUser = async () => {
  try {
    await signOut(auth);
    localStorage.removeItem("user"); // Remove from local storage
  } catch (error) {
    // console.error("Logout Error:", error);
    throw error;
  }
};
